import FootEconSec from '@economist/fabric-components/footer/footeconsec/FootEconSec';
import ScrollDepth from '@economist/fabric-components/utility/ScrollDepthTracker/ScrollDepth';
import UtilWebVitals from '@economist/fabric-components/utility/utilwebvitals/UtilWebVitals';
import React from 'react';
import { Helmet } from 'react-helmet';

import { Header } from '../Header';
import { PreloadStatic } from '../PreloadStatic';
import { Seo } from '../Seo';
import styles from './Layout.styles';

import '@/fonts/fonts.css';
import 'modern-normalize/modern-normalize.css';
import 'sal.js/dist/sal.css';

/**
 * @param children - used as content for layout
 * @param title - used as property for Seo component
 * @param description - used as property for Seo component
 * @param image - used as property for Seo component
 * @param commonData
 * @returns {JSX.Element}
 * @constructor
 */

const Layout = ({ children, title, description, image, commonData }) => {
  const { menu } = commonData;

  return (
    <>
      <Helmet>
        <script src="//cmp-cdn.p.aws.economist.com/latest/configs/impact.config.js"></script>
        <script src="//cmp-cdn.p.aws.economist.com/latest/cmp.min.js"></script>
      </Helmet>
      <UtilWebVitals />
      <ScrollDepth />
      <Seo title={title} description={description} image={image} />
      <PreloadStatic />
      <div css={styles}>
        <Header header={commonData.header} menu={menu} />
        <main>{children}</main>
        <FootEconSec />
      </div>
    </>
  );
};

export default Layout;
